import Form from "components/Reusable/Form/Form.js";
import { useContent } from "contexts/contentContext/contentContext.js";
import { securityFields } from "./formsFields.js";

const SecurityFormComponent = ({ body, getFormValuesRef, handleSubmit }) => {
  const { getTextByKey } = useContent();

  return (
    <div className="options-form-container">
      <div className="options-form-header">
        {getTextByKey("security-settings")}
      </div>
      <Form
        fieldsProps={{ field: "none" }}
        fields={securityFields}
        onSubmit={handleSubmit}
        submitProps={{
          title: getTextByKey("save"),
          className: "blank-button",
          hidden: true,
        }}
        defaultValuesObj={body}
        buttonProps={{ buttonsSize: "large" }}
        checkAndReturnValuesFunc={getFormValuesRef}
        // captchaProvider="cloudflare"
      />
    </div>
  );
};

export default SecurityFormComponent;
